import { trackEvent } from "@/lib/analytics";

// Robust link trigger that works even inside sandboxed preview iframes.
// Creates a real anchor and clicks it (browsers hand off tel:/mailto: to the
// OS and open http(s) links in a new tab from a genuine user gesture).
export function triggerLink(href, external = false) {
  try {
    const a = document.createElement("a");
    a.href = href;
    if (external) {
      a.target = "_blank";
      a.rel = "noopener noreferrer";
    }
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (e) {
    if (external) window.open(href, "_blank", "noopener,noreferrer");
    else window.location.href = href;
  }
}

export const doCall = (href, location = "") => {
  trackEvent("call_click", { location });
  triggerLink(href, false);
};

export const doEmail = (href, location = "") => {
  trackEvent("email_click", { location });
  triggerLink(href, false);
};

export const doWhatsApp = (href, location = "") => {
  trackEvent("whatsapp_click", { location });
  triggerLink(href, true);
};

export const doMaps = (href, location = "") => {
  trackEvent("directions_click", { location });
  triggerLink(href, true);
};

export const doExternal = (href, event, location = "") => {
  if (event) trackEvent(event, { location });
  triggerLink(href, true);
};
